module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Add to Garage","BTN_APPLY_QUOTE_CHANGES":"Apply Changes"}}


//////////////////
// WEBPACK FOOTER
// ../widget-commons-vehicle/src/Quote/i18n/en.json
// module id = ../widget-commons-vehicle/src/Quote/i18n/en.json
// module chunks = widget-7.1.6